import React from 'react'

import { statisticIntervals } from '../../../../constants'

const StatisticIntervalSelect = ({ interval, onIntervalChange }) => {
  const statisticIntervalsContent = statisticIntervals.map((statisticInterval, index, array) => {
    const isActive = interval === statisticInterval

    return (
      <button
        key={statisticInterval}
        className={`py-[6px] px-[10px] text-sm text-[#F67443] transition-colors duration-200 ease ${isActive ? 'bg-[#F9FAFB] font-semibold' : 'font-normal'} ${index === 0 ? 'rounded-l-[4px]' : ''} ${index === array.length - 1 ? 'rounded-r-[4px]' : 'border-r-[#F79009] border-r-[1px]'}`}
        onClick={() => onIntervalChange(statisticInterval)}
      >
        {statisticInterval}
      </button>
    )
  })

  return (
    <div
      className="flex items-center border-[#F79009] border-[1px] rounded-[4px] shadow-button"
      role="group"
    >
      {statisticIntervalsContent}
    </div>
  )
}

export default StatisticIntervalSelect
